import { callRpc } from "./client";

export interface NotificacaoItem {
  id?: string | number;
  titulo?: string;
  texto?: string;
  tempo?: string;
  avatar?: string;
  avatarUrl?: string;
  usuarioNome?: string;
  icone?: string | null;
}

export interface NotificacoesPainel {
  atividades: NotificacaoItem[];
  novidades: NotificacaoItem[];
  avisos: NotificacaoItem[];
}

export type AbaNotif = "atividades" | "novidades" | "avisos";

export async function obterNotificacoesPainel(): Promise<NotificacoesPainel> {
  const r = await callRpc<Partial<NotificacoesPainel>>("obterNotificacoesPainel").catch(() => null);
  return {
    atividades: r?.atividades ?? [],
    novidades: r?.novidades ?? [],
    avisos: r?.avisos ?? [],
  };
}

export async function limparNotificacoesPainel(): Promise<boolean> {
  const res = await callRpc<{ sucesso?: boolean }>("marcarNotificacoesUsuarioFalse").catch(() => null);
  return res?.sucesso === true;
}

export interface TotalNotificacoesPainel {
  atividades: number;
  novidades: number;
  avisos: number;
  total: number;
  latestId: number;
  latestKey: string;
}

export async function obterTotalNotificacoesPainel(): Promise<TotalNotificacoesPainel> {
  const r = await callRpc<Partial<TotalNotificacoesPainel>>("obterTotalNotificacoesPainel").catch(() => null);
  return {
    atividades: r?.atividades ?? 0,
    novidades: r?.novidades ?? 0,
    avisos: r?.avisos ?? 0,
    total: r?.total ?? 0,
    latestId: r?.latestId ?? 0,
    latestKey: r?.latestKey ?? String(r?.latestId ?? 0),
  };
}
